export default __webpack_public_path__ + "static/media/fondo.6b949c6c.jpg";